var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Message',{attrs:{"content":_vm.event.message.body,"user":_vm.event.user || _vm.event.customer || {},"timestamp":_vm.event.created,"media":_vm.event.message.media}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }